import React from 'react';

/**
 * Renders a project's color dot + name, prefixed with the team name when the
 * project belongs to a team. Single source of truth so every list, board,
 * agenda row and gallery card shows team origin the same way.
 *
 * Backend `GET /api/projects` already includes `team_name` on each project, so
 * callers don't need to load teams separately.
 */
export default function ProjectChip({
  project,
  className = '',
  showTeam = true,
  dotSize = 'w-2 h-2',
  textClass = '',
}) {
  if (!project) return null;
  const teamName = showTeam ? project.team_name : null;
  return (
    <span className={`inline-flex items-center gap-1.5 min-w-0 ${className}`}>
      <span
        className={`${dotSize} rounded-sm flex-shrink-0`}
        style={{ backgroundColor: project.color || '#6B7280' }}
      />
      <span className={`truncate ${textClass}`}>
        {teamName && (
          <>
            <span className="text-muted-foreground/70">{teamName}</span>
            <span className="text-muted-foreground/40 mx-1">/</span>
          </>
        )}
        <span>{project.name}</span>
      </span>
    </span>
  );
}
